export default __webpack_public_path__ + "static/media/drag_icon_recommendation.4e659fb3.svg";